module.exports = __webpack_public_path__ + "static/6GSNS-480x480-39916c132ca8dd9eb521e63f98587d6a.png";